import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type MainContainerProps = {
	className?: string;
	children: any;
};

export const MainContainer = ({ children, className }: MainContainerProps) => {
	return (
		<div className={clsx(styles.mainContainer, className)}>{children}</div>
	);
};
